<form class="my-8 flex flex-col gap-8" [formGroup]="formGroup" (ngSubmit)="onBronzeSubscriptionFormSubmit()">
    <div class="flex w-full flex-col gap-8 lg:flex-row">
        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="firstname">
                {{ "bronze_subscription_form_block.firstname" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="firstname"
                placeholder="John*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'firstname'"
            />
        </div>

        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="lastname">
                {{ "bronze_subscription_form_block.lastname" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="lastname"
                placeholder="Doe*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'lastname'"
            />
        </div>
    </div>

    <div class="flex w-full flex-col gap-8 lg:flex-row">
        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="business_name">
                {{ "bronze_subscription_form_block.business_name" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="businessName"
                placeholder="{{ 'bronze_subscription_form_block.business_name_placeholder' | transloco }}*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'businessName'"
            />
        </div>

        <div class="flex w-full flex-col gap-1 lg:w-1/2">
            <label class="text-label-large text-neutral-20" for="email">
                {{ "bronze_subscription_form_block.email" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="email"
                placeholder="john.doe@example.com*"
                type="text"
                [class.border-red-500]="formGroup | formControlHasError: 'email'"
            />
        </div>
    </div>

    <div class="flex w-full gap-8">
        <div class="flex w-full flex-col gap-1">
            <label class="text-label-large text-neutral-20" for="websiteUrl">
                {{ "bronze_subscription_form_block.website_url" | transloco }}
            </label>
            <input
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 w-full rounded-md border px-4 py-3"
                formControlName="websiteUrl"
                placeholder="{{ 'bronze_subscription_form_block.website_url_placeholder' | transloco }}"
                type="text"
            />
        </div>
    </div>

    <div class="flex w-full gap-8">
        <div class="flex w-full flex-col gap-1">
            <label class="text-label-large text-neutral-20" for="message">
                {{ "bronze_subscription_form_block.message" | transloco }}
            </label>
            <textarea
                class="placeholder:text-neutral-variant-60 border-neutral-variant-40/20 min-h-30 w-full rounded-md border px-4 py-3"
                formControlName="message"
                placeholder="{{ 'bronze_subscription_form_block.message_placeholder' | transloco }}"
                type="text"
            ></textarea>
        </div>
    </div>

    <div class="mx-auto flex w-full flex-col justify-start gap-8 lg:max-w-150 lg:min-w-150">
        <button
            class="bg-primary hover:bg-primary/80 mx-auto w-full cursor-pointer rounded-md px-6 py-3 text-white disabled:cursor-not-allowed disabled:opacity-50 lg:w-auto lg:max-w-150 lg:min-w-150"
            type="submit"
            [disabled]="isSubmitting() || (formGroup | formControlHasError)"
        >
            {{ "bronze_subscription_form_block.submit" | transloco }}
        </button>
    </div>
</form>
